module.exports = __webpack_public_path__ + "img/icon-healthy.c8c06e1f.png";